import React, { useState, useMemo } from 'react';
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import GetAppIcon from "@material-ui/icons/GetApp";
import Button from "@material-ui/core/Button";
import ClipLoader from "react-spinners/ClipLoader";
import BotonCargarArchivo from './BotonCargarArchivo';
import axios from "axios";
import Slider from "react-slick";
import Swal from "sweetalert2";
import { generateCommitmentLetter } from '../../utils/pdfGenerator';
import { generarCartaCompromiso } from '../../utils/pdf';

// Importar CSS y JS
import "./FormDocumentacion.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "jquery-mask-plugin/dist/jquery.mask.min";

// Importar Multimedia
import logoufg from "../../assets/images/logo-ufg.png";
import cartaPDF from "../../assets/docs/solicitud-graduacion.pdf";

const FormDocumentacion = ({
    respDataFormInicial,
    respDataForm,
    respProceso,
    respTitulacion,
    resToken,
    esTecnico
}) => {
    const [dataFormInical, setDataFormInical] = useState(respDataFormInicial);
    const [loading, setLoading] = useState(true);
    const [arrDocumentosApi, setArrDocumentosApi] = useState([]);
    const [documentosCargados, setDocumentosCargados] = useState([]);
    const [permisoCartaCompromiso, setPermisoCartaCompromiso] = useState(false);
    const proceso = respProceso;
    const dataForm = respDataForm;
    const tipoTitulacion = respTitulacion;

    const settings = {
        dots: true,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        centerPadding: "60px",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: true,
                    centerPadding: "60px",
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerPadding: "60px",
                    infinite: false,
                },
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: "100px",
                    infinite: false,
                    dots: false,
                },
            },
        ],
    };

    const requestDocumentos = useMemo(() => ({
        Proceso: proceso,
        TipoIngreso: dataFormInical.TipoIngreso,
        IdTipoTitulacion: tipoTitulacion,
        Modalidad: proceso === "PROCESO DE GRADUACIÓN" ? dataForm.Modalidad :
            proceso === "MAESTRÍA" ? dataForm.MaesOpciones : "",
        Opcion: proceso === "PROCESO DE GRADUACIÓN" && dataForm.Modalidad === "ESPECIALIZACIÓN" ? dataForm.ModOpciones :
            proceso === "MAESTRÍA" ? dataForm.ModOpciones : "",
    }), [proceso, dataFormInical.TipoIngreso, tipoTitulacion, dataForm.Modalidad, dataForm.MaesOpciones, dataForm.ModOpciones]);


    //Consultar documentos
    React.useEffect(() => {
        const fetchDocumentos = async () => {
            if (!dataFormInical.Carnet) return;

            try {
                // Consultar documentos del proceso
                const documentosResponse = await axios({
                    url: process.env.REACT_APP_CATALOGOAPI + "tipodocumentosproceso",
                    method: "post",
                    data: JSON.stringify(requestDocumentos),
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                let documentos = documentosResponse.data.Documentos || [];

                // Consultar permiso de carta compromiso
                try {
                    const cartaResponse = await axios({
                        url: process.env.REACT_APP_DOCUMENTACIONAPI + "permite-carta-compromiso/" + dataFormInical.Carnet + "?ciclo=" + process.env.REACT_APP_CICLO,
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });

                    console.log("Respuesta permiso carta compromiso:", proceso );

                    if (cartaResponse.data.permiso === true && (proceso === "NUEVO INGRESO" || proceso === "EQUIVALENCIA") ) {
                        setPermisoCartaCompromiso(true);

                        // Agregar documento CARTA COMPROMISO al inicio de la lista
                        const cartaCompromisoDoc = {
                            IdTipoDocumentoGD: 67,
                            IdDocumentoUnidad: 50,
                            NombreDocumentoPendiente: "CARTA COMPROMISO",
                            Documento: null,
                            IdEstadoDocumento: 2,
                            Activo: 0,
                        };

                        documentos = [cartaCompromisoDoc, ...documentos];
                    }
                } catch (cartaError) {
                    setPermisoCartaCompromiso(false);
                }

                setArrDocumentosApi(documentos);
                setLoading(false);

            } catch (err) {
                setArrDocumentosApi(null);
                setLoading(false);
            }
        };

        fetchDocumentos();
    }, [dataFormInical.Carnet, requestDocumentos]);

    React.useEffect(() => {
        setDataFormInical(respDataFormInicial);
    }, [respDataFormInicial]);

    const fullName = `${dataFormInical.Nombres} ${dataFormInical.PrimerApellido} ${dataFormInical.SegundoApellido}`;
    const isGraduationProcess = proceso === "PROCESO DE GRADUACIÓN";
    const isMaestria = proceso === "MAESTRÍA";
    const isNewOrEquivalent = proceso === "NUEVO INGRESO" || proceso === "EQUIVALENCIA";
    const showDownloadSection = isGraduationProcess || isMaestria;

    // Función para manejar cuando se carga un documento
    const handleDocumentoCargado = (nombreDocumento, documentoData) => {
        setDocumentosCargados(prev => {
            const exists = prev.find(doc => doc.nombreDocumento === nombreDocumento);
            if (exists) {
                // Actualizar documento existente
                return prev.map(doc =>
                    doc.nombreDocumento === nombreDocumento
                        ? { ...doc, ...documentoData }
                        : doc
                );
            } else {
                // Agregar nuevo documento
                return [...prev, { nombreDocumento, ...documentoData }];
            }
        });
    };

    // Función para manejar cuando se elimina un documento
    const handleDocumentoEliminado = (nombreDocumento) => {
        setDocumentosCargados(prev =>
            prev.filter(doc => doc.nombreDocumento !== nombreDocumento)
        );
    };

    // Función para generar y descargar la carta compromiso
    const handleDownloadCartaCompromiso = () => {
        try {
            generarCartaCompromiso(proceso, { carnet: dataFormInical.Carnet, nombres: dataFormInical.Nombres, primerApellido: dataFormInical.PrimerApellido, segundoApellido: dataFormInical.SegundoApellido, carrera: dataFormInical.NombreCarrera, documentos: arrDocumentosApi });

        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Hubo un problema al generar la declaración jurada",
                icon: "error",
                confirmButtonText: "Reintentar"
            });
        }
    };

    // Función para preparar los datos de la solicitud
    const prepareRequestData = () => {
        // Actualizar arrDocumentosApi con los documentos cargados
        const updatedDocuments = arrDocumentosApi.map(doc => {
            const documentoCargado = documentosCargados.find(
                cargado => cargado.nombreDocumento === doc.NombreDocumentoPendiente
            );

            if (documentoCargado) {
                return {
                    ...doc,
                    Documento: documentoCargado.Documento,
                    IdEstadoDocumento: 3, // Documento cargado
                    Activo: false
                };
            }
            return doc;
        });

        let idEst;
        if (proceso === "PROCESO DE GRADUACIÓN" || proceso === "MAESTRÍA") {
            idEst = 6;
        } else {
            idEst = 2;
        }


        return {
            Token: resToken,
            IdCiclo: process.env.REACT_APP_IDCICLO,
            Ciclo: process.env.REACT_APP_CICLO,
            IdSede: dataFormInical.IdSede,
            Carnet: dataFormInical.Carnet,
            Nombres: dataFormInical.Nombres,
            PrimerApellido: dataFormInical.PrimerApellido,
            SegundoApellido: dataFormInical.SegundoApellido,
            NombreCarrera: dataFormInical.NombreCarrera,
            Telefono: respDataForm.Telefono,
            Email: respDataForm.Email,
            Proceso: proceso,
            Documentos: updatedDocuments,
            Activo: 1,
            IdEstado: idEst, // Estado completado
            FechaRegistro: new Date(),
            FechaModificacion: new Date(),
            CartaJurada: false // Por defecto
        };
    };

    // Función para validar documentos según el proceso
    const validateDocuments = () => {
        const validation = {
            isValid: false,
            message: "",
            title: "IMPORTANTE"
        };

        // Verificar si hay documentos cargados
        if (documentosCargados.length === 0) {
            validation.message = "Debe cargar al menos un documento para continuar";
            validation.title = "Sin documentos";
            return validation;
        }

        // Buscar documentos con datos nulos en el array original
        const documentosNulos = arrDocumentosApi.filter(doc => {
            const cargado = documentosCargados.find(c => c.nombreDocumento === doc.NombreDocumentoPendiente);
            return !cargado;
        });

        // Buscar carta compromiso cargada
        const cartaCompromisoSubida = documentosCargados.find(
            doc => doc.nombreDocumento === "CARTA COMPROMISO"
        );

        // Lista de documentos opcionales
        const documentosOpcionales = [
            "NOTAS DE BACHILLER",
            "COMPROBANTE DE PAGO",
            "DUI",
            "NIT",
            "PRUEBA DE ORIENTACIÓN VOCACIONAL"
        ];

        // Filtrar documentos obligatorios faltantes
        const documentosObligatoriosFaltantes = documentosNulos.filter(doc =>
            !documentosOpcionales.includes(doc.NombreDocumentoPendiente) &&
            doc.NombreDocumentoPendiente !== "CARTA COMPROMISO"
        );

        // Validaciones específicas por proceso
        if (proceso === "MAESTRÍA" || proceso === "PROCESO DE GRADUACIÓN") {
            // Para graduación/maestría: validar documentos especiales
            if (dataForm.Modalidad === "ESPECIALIZACIÓN" && dataForm.ModOpciones === "CERTIFICACIÓN") {
                // Validar certificaciones
                const certificaciones = [
                    "CERTIFICACIÓN MICROSOFT",
                    "CERTIFICACIÓN PMI",
                    "CERTIFICACIÓN CISCO",
                    "CERTIFICACIÓN ORACLE"
                ];

                const certificacionCargada = documentosCargados.some(doc =>
                    certificaciones.includes(doc.nombreDocumento)
                );

                if (!certificacionCargada) {
                    validation.message = "Se requiere al menos una certificación.";
                    return validation;
                }

                // Verificar que otros documentos estén completos
                const otrosDocumentosFaltantes = documentosObligatoriosFaltantes.filter(doc =>
                    !certificaciones.includes(doc.NombreDocumentoPendiente)
                );

                if (otrosDocumentosFaltantes.length > 0) {
                    validation.message = "Faltan documentos obligatorios.";
                    return validation;
                }
            } else {
                // Para otros tipos de graduación/maestría - todos los documentos son obligatorios
                if (documentosObligatoriosFaltantes.length > 0) {
                    validation.message = "Todos los documentos son requeridos.";
                    return validation;
                }
            }
        } else {
            // Para otros procesos (NUEVO INGRESO, EQUIVALENCIA)
            if (documentosObligatoriosFaltantes.length > 0 && !cartaCompromisoSubida) {
                validation.message = "Faltan documentos obligatorios.";
                return validation;
            }
        }

        validation.isValid = true;
        return validation;
    };

    // Función principal de envío de documentos
    const sendDocs = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // Validar documentos
            const validation = validateDocuments();
            if (!validation.isValid) {
                Swal.fire({
                    title: `<strong>${validation.title}</strong>`,
                    icon: "info",
                    html: validation.message,
                    showConfirmButton: false,
                    showCloseButton: true,
                });
                setLoading(false);
                return;
            }

            // Preparar datos para envío
            const requestData = prepareRequestData();

            // Realizar envío al servidor
            // const response = []
            const response = await axios({
                url: process.env.REACT_APP_DOCUMENTACIONAPI + "savedocumentos",
                method: "post",
                data: JSON.stringify(requestData),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            // Manejar respuesta del servidor
            let estadoSave, messageSave, tituloSave;

            switch (response.data.Code) {
                case 200:
                    tituloSave = "TOKEN: " + resToken;
                    estadoSave = "success";
                    messageSave = response.data.Message;
                    break;
                case 409:
                    tituloSave = "LO SENTIMOS";
                    estadoSave = "error";
                    messageSave = response.data.Message;
                    break;
                case 400:
                    tituloSave = "LO SENTIMOS";
                    estadoSave = "warning";
                    messageSave = response.data.Message;
                    break;
                case 203:
                    tituloSave = "IMPORTANTE";
                    estadoSave = "info";
                    messageSave = response.data.Message;
                    break;
                default:
                    tituloSave = "ERROR";
                    estadoSave = "error";
                    messageSave = "Al parecer existe un problema en el recurso, por favor intenta más tarde o puedes comunicarte al 2209-2834 para reportar el incidente.";
                    break;
            }

            Swal.fire({
                title: `<strong>${tituloSave}</strong>`,
                icon: estadoSave,
                html: messageSave,
                showConfirmButton: false,
                showCloseButton: true,
            }).then(() => {
                if (response.data.Code === 200) {
                    window.location.reload(true);
                }
            });

        } catch (error) {
            Swal.fire({
                title: "<strong>ERROR DE CONEXIÓN</strong>",
                icon: "warning",
                html: '<p><font size="3">Ocurrió un error al intentar guardar tus documentos, intenta nuevamente.</p>',
                showConfirmButton: false,
                showCloseButton: true,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="wrap-container pt-0">
            <div className="pl-md-5 pr-md-5 content-container">
                <MDBContainer>
                    <MDBRow>
                        <MDBCol className="text-center">
                            <img src={logoufg} className="img-fluid logo-forms" alt="Logo UFG" />
                            <hr className="hr-logo" />
                        </MDBCol>
                    </MDBRow>

                    <MDBRow>
                        <MDBCol className="col-12 mt-4 mt-lg-0">
                            <MDBRow>
                                <MDBCol className="col-12 col-md-7 mb-4 title-sub-op">
                                    <b>Nombre:</b> {fullName}
                                </MDBCol>
                                <MDBCol className="col-12 col-md-5 mb-4 title-sub-op">
                                    <b>Carné:</b> {dataFormInical.Carnet}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol className="col-12 col-md-7 mb-4 title-sub-op">
                                    <b>Carrera:</b> {dataFormInical.NombreCarrera}
                                </MDBCol>
                                <MDBCol className="col-12 col-md-5 mb-4 title-sub-op">
                                    <b>Modalidad:</b> {dataFormInical.Modalidad}
                                </MDBCol>
                            </MDBRow>
                        </MDBCol>
                    </MDBRow>

                    <MDBRow className="mb-2">
                        <MDBCol className={
                            showDownloadSection || permisoCartaCompromiso
                                ? "col-12 col-md-7 pt-3 pb-3 pe-5 text-justify title-sub-op"
                                : "col-12 pt-3 pb-3 text-justify title-sub-op"
                        }>
                             {!isNewOrEquivalent && (
                                 <>
                                     <p>Recuerda que, tu título de bachiller debe estar apostillado del país de procedencia, presentarlo en el Ministerio de Educación, Ciencia y Tecnología de El Salvador (MINEDUCYT) para realizar el trámite de Acuerdo de incorporación para que tu título sea válido.</p>
                                     <p>No olvides que el trámite es personal.</p>
                                 </>
                             )}
                            <br />
                            <p className='pt-4'>
                                Documentos requeridos para {isGraduationProcess ? "el" : "el proceso de"} <b>{proceso}</b>
                            </p>
                            {dataForm.Modalidad && dataForm.Modalidad !== "TÉCNICO" && (
                                <><br />Con modalidad <b>{dataForm.Modalidad}</b></>
                            )}
                            {dataForm.ModOpciones && dataForm.Modalidad === "ESPECIALIZACIÓN" && (
                                <><br />y opción <b>{dataForm.ModOpciones}</b></>
                            )}
                            {dataForm.MaesOpciones && isMaestria && (
                                <><br />Con modalidad <b>{dataForm.MaesOpciones}</b></>
                            )}
                            {isGraduationProcess && dataForm.Modalidad === "EXCELENCIA ACADÉMICA" && (
                                <><br />Si no cuentas con tu ACTA DE APROBACIÓN DEL CURSO BÁSICO PARA EGRESADOS, puedes subir tu resolución a la solicitud al Consejo Directivo.</>
                            )}
                        </MDBCol>

                        {showDownloadSection && (
                            <MDBCol className="col-12 offset-md-1 col-lg-4 pt-4 pb-4 pt-lg-0 pb-0 text-center title-sub-op bg-g d-flex align-items-center justify-content-center br-30">
                                <div>
                                    <label className="title-sub-op-orange mb-0 mt-3 font-16">
                                        SOLICITUD DEL TRÁMITE <br />DE GRADUACIÓN
                                    </label>
                                    <div className="d-flex align-items-center flex-column over-h btn-carta-3 mb-3 mb-lg-0">
                                        <a href={cartaPDF} download="Solicitud del trámite de Graduación">
                                            <GetAppIcon style={{ fontSize: 40, color: "#0D3B70" }} />
                                        </a>
                                        <h6>DESCARGAR AQUÍ</h6>
                                    </div>
                                </div>
                            </MDBCol>
                        )}

                        {permisoCartaCompromiso && (
                            <MDBCol className="col-12 offset-md-1 col-lg-4 pt-4 pb-4 pt-lg-0 pb-0 text-center title-sub-op bg-g d-flex align-items-center justify-content-center br-30">
                                <div>
                                    <label className="title-sub-op-orange mb-3 mt-3 font-16">
                                        DECLARACIÓN JURADA
                                    </label>
                                    <div className="d-flex align-items-center flex-column over-h btn-carta-3 mb-3 mb-lg-0">
                                        <button
                                            onClick={handleDownloadCartaCompromiso}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: '5px',
                                                borderRadius: '50%',
                                                transition: 'background-color 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#eee'}
                                            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                            title="Generar y descargar declaración jurada"
                                        >
                                            <GetAppIcon style={{ fontSize: 40, color: "#0D3B70" }} />
                                        </button>
                                        <h6>DESCARGAR AQUÍ</h6>
                                    </div>
                                </div>
                            </MDBCol>
                        )}
                    </MDBRow>
                    <MDBRow className="mb-2 mt-5 justify-content-between">
                        <MDBCol className="col-md-6">
                            <p className="doc-pendientes h5">CARGA TUS DOCUMENTOS</p>
                        </MDBCol>
                    </MDBRow>
                    <hr className="hr-logo" />

                    {loading === true ? (
                        <div className="wrap-loader">
                            <div className="contenedorCenterVertical">
                                <ClipLoader size={180} color={"#EF8903"} />
                            </div>
                        </div>
                    ) : (
                        <div>
                            {arrDocumentosApi != null ? (
                                <form action="#" onSubmit={(e) => e.preventDefault()}>
                                    <MDBRow>
                                        <MDBCol className="col pb-5 pt-5 p-md-4 wrap-slider">
                                            <Slider {...settings}>
                                                {arrDocumentosApi &&
                                                    arrDocumentosApi.map((doc) => (
                                                        <div
                                                            className="item-slider"
                                                            key={doc.IdDocumentoUnidad}
                                                        >
                                                            <BotonCargarArchivo
                                                                doc={doc}
                                                                nombreDocumento={doc.NombreDocumentoPendiente}
                                                                idDocumento={doc.IdDocumentoUnidad}
                                                                idTipoDocumentoGD={doc.IdTipoDocumentoGD}
                                                                onDocumentoCargado={handleDocumentoCargado}
                                                                onDocumentoEliminado={handleDocumentoEliminado}
                                                                documentosCargados={documentosCargados}
                                                            />
                                                        </div>
                                                    ))}
                                            </Slider>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol className="p-3 text-right">
                                            <Button
                                                variant="contained"
                                                onClick={sendDocs}
                                                className="btn-send-form"
                                                disabled={loading || documentosCargados.length === 0}
                                            >
                                                {loading ? "Enviando..." : `Enviar`}
                                            </Button>
                                        </MDBCol>
                                    </MDBRow>
                                </form>
                            ) : (
                                <div className="document-alert">
                                    <h1>
                                        Existe un problema con el recurso, comunicate al 2209-2927
                                    </h1>
                                </div>
                            )}
                        </div>
                    )}

                </MDBContainer>
            </div>
        </div>
    );
};

export default FormDocumentacion;